export default __webpack_public_path__ + "static/media/error.2f8a2110.svg";